import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

export const PrivacyPolicyPage = () => {
	return (
		<PageMeta title="利用規約" url={generatePath(PATHS.POLICY.SERVICE_POLICY)}>
			<style>{`
				.bg-chillnn-bg-page {
					background-color: #f0f0f0; /* Example background color */
				}
				.px-5 {
					padding-left: 1.25rem; /* 20px */
					padding-right: 1.25rem; /* 20px */
				}
				.py-16 {
					padding-top: 4rem; /* 64px */
					padding-bottom: 4rem; /* 64px */
				}
				.mx-20 {
					margin-left: 5rem; /* 80px */
					margin-right: 5rem; /* 80px */
				}
				.text-sm {
					font-size: 0.875rem; /* 14px */
				}
				.pb-12 {
					padding-bottom: 3rem; /* 48px */
				}
				.text-center {
					text-align: center;
				}
				.text-xl {
					font-size: 1.25rem; /* 20px */
				}
				.font-semibold {
					font-weight: 600;
				}
				.subTitle {
					padding-top: 0.75rem; /* 12px */
					padding-bottom: 0.75rem; /* 12px */
					font-weight: 600;
					font-size: 1.125rem; /* 18px */
				}
				.paragraph {
					margin-top: 0.375rem; /* 6px */
					margin-bottom: 0.375rem; /* 6px */
				}
				.sub {
					margin-left: 1rem; /* Indent for sub-items */
				}
			`}</style>

			<div className="bg-bg-layer-500 px-5 py-16 text-sm lg:mx-20">
				<div className="pb-12 text-center text-xl font-semibold">
					<h1>プライバシーポリシー</h1>
				</div>
				<div>
					<div>
						<p>
							株式会社CHILLNN（以下，「当社」）は、お客様の個人情報保護法の重要性について認識し、お客様情報の保護に関する法律（以下「個人情報保護法」）を遵守するとともに、お客様についてのお客様情報を含むお客様情報の取扱いについて以下のプライバシーポリシー（以下「本ポリシー」）に従い、適切な取扱および保護に努めます。
						</p>
					</div>
					<div>
						<h2 className="subTitle">第１条（お預かりするお客様情報について）</h2>
						<p className="paragraph">1. 本サービスを通じて取得・収集させていただく方法</p>
						<p className="paragraph">
							本サービス上でお客様自身が入力されたお客様情報を、当社は取得・収集させていただきます。
						</p>

						<p className="paragraph">2. 電子メール、書面、電話等の方法で取得・収集させていただく方法</p>
						<p className="paragraph">
							お客様から当社に対し、電子メール、書面、電話等の手段によってご提供いただいたお客様情報を当社は取得・収集させていただきます。
						</p>
						<p className="paragraph">
							3.
							お客様が当社サービスの利用において、他のサービスと連携を許可することにより、当該他のサービスからご提供いただく情報
						</p>
						<p className="paragraph">
							お客様が当社サービスを利用するにあたり、ソーシャルネットワーキングサービス等の他のサービスとの連携を許可した場合には、その許可の際にご同意いただいた内容に基づき、以下の情報を当該外部サービスから取得・収集させていただきます。
						</p>
						<p className="sub">3.1. 当該外部サービスでお客様が利用するID</p>
						<p className="sub">
							3.2 その他当該外部サービスのプライバシー設定によりお客様が連携先に開示を認めた情報
						</p>
						<p className="paragraph">
							4. お客様が当社サービスを利用するにあたって、当社が取得・収集する情報
						</p>
						<p className="paragraph">
							当社は、当社サービスへのアクセス状況やそのご利用方法に関する情報を取得・収集させていただきます。これには以下の情報が含まれます。
						</p>
						<p className="sub">・リファラ</p>
						<p className="sub">・IPアドレスおよび個体識別情報</p>
						<p className="sub">・インターネットドメイン名</p>
						<p className="sub">・サーバーアクセスログに関する情報</p>
						<p className="sub">・Cookie、ADID、IDFAその他の識別子</p>
						<p className="paragraph">
							なお、当社サービス上での事前決済は全て他社決済サービスを介したクレジットカード決済で行われ、当社は他社決済サービスへのアクセストークンを除き、完全なクレジットカード情報を取得しません。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第２条（利用目的について）</h2>
						<p className="paragraph">
							当社のお客様情報の具体的な利用目的は以下のとおりです。これらの利用目的以外には、第４項に記載する場合またはお客様に個別に同意をいただいた場合を除き、利用いたしません。
						</p>
						<p className="sub">1. 当社サービスの提供のため</p>
						<p className="sub">2. 当社サービスに関するご案内、お問い合わせ等への対応のため</p>
						<p className="sub">3. 当社サービスに関する当社の規約に違反する行為に対する対応のため</p>
						<p className="sub">4. 当社サービスに関する規約等の変更などを通知するため</p>
						<p className="sub">5. 当社の更なるサービス向上のための調査、またその謝礼等をお送りするため</p>
						<p className="sub">6. 当社サービスの改善、当社の新サービスの開発等に役立てるため</p>
						<p className="sub">
							7. 当社サービスに関連して、個人を識別できない形式に加工した統計データを作成するため
						</p>
						<p className="sub">
							8.
							決済における不正利用防止やセキュリティ強化のための本人認証サービスを実施する第三者に提供するため
						</p>
						<p className="sub">9. 別途お客様に明示しまたは公表した利用目的のため</p>
						<p className="sub">10. その他、上記利用目的に付随する目的のため</p>
					</div>

					<div>
						<h2 className="subTitle">第３条（情報の取扱いについて）</h2>
						<p className="sub">
							1.
							お客様等からお預かりした情報は、適切且つ慎重に管理し、その漏洩、紛失、誤用、改ざん、不正アクセスの危険防止のため、必要かつ合理的な安全管理措置を講じます。また、通信手段を用いてご提供いただく際には通信途上での第三者による傍受に備え、必要に応じてSSL（Secure
							Socket Layer）暗号化通信などのセキュリティ技術により安全性の確保に努めます。
						</p>
						<p className="sub">
							2.
							お客様等からお預かりした情報は、当社のサービスの質を向上させ、お客様等の便宜を図るために、取扱いの一部を外部業者に委託することがありますが、この場合も業務委託先に対して適切な管理を行うよう指示・監督を行います。
						</p>
						<p className="sub">3. 当社サービスに関する当社の規約に違反する行為に対する対応のため</p>
						<p className="sub">4. 当社サービスに関する規約等の変更などを通知するため</p>
						<p className="sub">5. 当社の更なるサービス向上のための調査、またその謝礼等をお送りするため</p>
						<p className="sub">6. 当社サービスの改善、当社の新サービスの開発等に役立てるため</p>
						<p className="sub">
							7. 当社サービスに関連して、個人を識別できない形式に加工した統計データを作成するため
						</p>
						<p className="sub">8. 別途お客様に明示しまたは公表した利用目的のため</p>
						<p className="sub">9. その他、上記利用目的に付随する目的のため</p>
					</div>
					<div>
						<h2 className="subTitle">第４条（第三者への開示・提供について）</h2>
						<p className="sub">1. お客様ご本人の同意がある場合</p>
						<p className="sub">
							2.
							お客様にサービスを提供する際に必要な範囲内においてお客様情報の取扱いの全部または一部を委託する場合
						</p>
						<p className="sub">
							3.
							人の生命、身体または財産の保護のために必要な場合であって、お客様等の同意を得ることが困難な場合
						</p>
						<p className="sub">
							4.
							不正アクセス・脅迫等の違法行為があり、そのトラブルの解決のために当社がお客様情報の開示・提供を必要と判断した場合
						</p>
						<p className="sub">5. 合併その他の事由による事業の承継に伴ってお客様情報が提供される場合</p>
						<p className="sub">
							6.
							国の機関もしくは地方公共団体その他の公的機関から法令等に基づきお客様情報提供を求められ、提供を拒否する合理的な理由がない場合
						</p>
						<p className="sub">7. その他、個人情報保護法その他の法令で認められる場合</p>
					</div>
					<div>
						<h2 className="subTitle">第５条（お客様情報の訂正および利用停止等について）</h2>
						<p className="sub">
							1.
							当社は、お客様から、（１）お客様情報が真実でないという理由によって個人情報保護法の定めに基づきその内容の訂正を求められた場合、および（２）お客様情報があらかじめ公表された利用目的の範囲を超えて取扱われているという理由または偽りその他不正の手段により取得・収集されたものであるという理由により、その利用の停止を求められた場合には、お客様ご本人からのご請求であることを確認の上で遅滞なく必要な調査を行い、その結果に基づき、お客様情報の内容の訂正または利用停止を行い、その旨をお客様に通知します。なお、訂正または利用停止を行わない旨の決定をしたときは、お客様に対しその旨を通知いたします。
						</p>
						<p className="sub">
							2.
							当社は、お客様から、お客様のお客様情報について消去を求められた場合、当社が当該請求に応じる必要があると判断した場合は、お客様ご本人からのご請求であることを確認の上で、お客様情報の消去を行い、その旨をお客様に通知します。
						</p>
						<p className="sub">
							3.
							個人情報保護法その他の法令により、当社が訂正等または利用停止等の義務を負わない場合は、第１項および第２項の規定は適用されません。
						</p>
					</div>
					<div>
						<h2 className="subTitle">第６条（プライバシーポリシーの変更手続について）</h2>
						<p className="paragraph">
							1. 当社は以下の場合に、当社の裁量により、プライバシーポリシーを変更することができます。
						</p>
						<p className="sub">1.1. プライバシーポリシーの変更が、ユーザーの一般の利益に適合するとき。</p>
						<p className="sub">
							1.2
							プライバシーポリシーの変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき。
						</p>
						<p className="paragraph">
							2.
							当社は前項によるプライバシーポリシーの変更にあたり、変更後のプライバシーポリシーの効力発生日の１か月前までに、プライバシーポリシーを変更する旨及び変更後のプライバシーポリシーの内容とその効力発生日を当社ウェブサイト（URL：https://www.chillnn.com）に掲示し、またはユーザーに電子メールで通知します。
						</p>
						<p className="paragraph">
							3.
							法令上、利用者の同意が必要となるような内容の変更の場合は，当社所定の方法で利用者の同意を得るものとします。
						</p>
					</div>
					<div>
						<h2 className="subTitle">第７条（お問い合わせ窓口について）</h2>
						<p className="paragraph">
							ご意見、ご質問、苦情のお申出その他お客様情報の取扱いに関するお問い合わせは、下記の窓口までお願いいたします。
						</p>
						<p className="sub">住所：京都府京都市下京区花屋町通櫛笥西入り薬園町174−9</p>
						<p className="sub">株式会社CHILLNN</p>
						<p className="sub">連絡先： customer@chillnn.com</p>
					</div>

					<div className="mt-6 text-right">
						<h3 className="font-semibold">２０２０年 ３月 ２日 制定</h3>
						<h3 className="font-semibold">２０２０年 ４月 ３日 改定</h3>
						<h3 className="font-semibold">２０２１年 ３月 １日 改定</h3>
						<h3 className="font-semibold">２０２４年 ８月 ２日 改定</h3>
						<p>（住所変更）</p>
						<h3 className="font-semibold">２０２４年 9月 11日 改定</h3>
						<p>（第２条８項追加）</p>
					</div>
				</div>
			</div>
		</PageMeta>
	);
};
